import { render } from "./TransUnion.vue?vue&type=template&id=d7b7bac6"
import script from "./TransUnion.vue?vue&type=script&lang=js"
export * from "./TransUnion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__